module.exports = __webpack_public_path__ + "img/I_O_19_Extended_Chetumal.8443a971.png";